import type { RouteLocationNormalizedLoaded, Router } from "vue-router";

import { VIEW_MODE_TO_DEFAULT_ROUTE_NAME } from "~/constants/viewMode";
import { ViewMode } from "~/shared/enums";
import type { useAppStore, useUserStore } from "~/stores";

type AppStore = ReturnType<typeof useAppStore>;
type UserStore = ReturnType<typeof useUserStore>;

type SwitchViewModeOptions = {
  appStore: AppStore;
  router: Router;
  userStore: UserStore;
};

const isModeRoute = (route: RouteLocationNormalizedLoaded) =>
  route.name === "task" || route.name === "build_setup" || route.name === "chat";

const hasProjectsEquivalent = (route: RouteLocationNormalizedLoaded) =>
  route.name === "task" && !!route.params.taskDuidAndSlug;

export const switchViewMode = async (mode: ViewMode, { appStore, router, userStore }: SwitchViewModeOptions) => {
  const defaultRouteName = VIEW_MODE_TO_DEFAULT_ROUTE_NAME[mode];

  if (mode === ViewMode.PROJECTS) {
    const route = router.currentRoute.value;
    if (isModeRoute(route)) {
      appStore.setTaskDetailOpen(false);
      if (!hasProjectsEquivalent(route)) {
        await router.push(appStore.lastProjectsModePath ?? { name: defaultRouteName });
      }
    }
    userStore.setViewMode(mode);
    if (route.name === "build_chat") {
      await router.push({ name: "task", params: { taskDuidAndSlug: route.params.taskDuid } });
    }
    return;
  }

  if (mode === ViewMode.CHATS) {
    if (router.currentRoute.value.name !== defaultRouteName) {
      await router.push({ name: defaultRouteName });
    }
    userStore.setViewMode(mode);
    return;
  }

  userStore.setViewMode(mode);

  if (router.currentRoute.value.name !== defaultRouteName) {
    await router.push({ name: defaultRouteName });
  }
};
